import log from "loglevel"

import config from "../config"

const { showAllLogs, } = config.appSettings 

if (showAllLogs) log.enableAll()
else log.disableAll()


export default {
  info: log.info,
  debug: log.debug,
  error: log.error,
  warn: log.warn,
  trace: log.trace,
  log: log.debug
}